/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidPay200,
  PostApiV1IndividualpaymentParcelsParcelidPay400,
  PostApiV1IndividualpaymentParcelsParcelidPay401,
  PostApiV1IndividualpaymentParcelsParcelidPay404,
  PostApiV1IndividualpaymentParcelsParcelidPay500,
  PostApiV1IndividualpaymentParcelsParcelidPayMutationRequest,
  PostApiV1IndividualpaymentParcelsParcelidPayMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidPayPathParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidPay.ts";
import { individualPaymentPayParcelViewModelSchema } from "../individualPaymentPayParcelViewModelSchema.ts";

export const postApiV1IndividualpaymentParcelsParcelidPayPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidPayPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidPay200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidPay200>;

/**
 * @description Dados inválidos
 */
export const postApiV1IndividualpaymentParcelsParcelidPay400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidPay400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidPay401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidPay401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1IndividualpaymentParcelsParcelidPay404Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidPay404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidPay500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidPay500>;

export const postApiV1IndividualpaymentParcelsParcelidPayMutationRequestSchema =
  z.lazy(
    () => individualPaymentPayParcelViewModelSchema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidPayMutationRequest>;

export const postApiV1IndividualpaymentParcelsParcelidPayMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsParcelidPay200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidPayMutationResponse>;
